import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListInvitedSubscribers from '../../components/subscribers/list-invited-subscribers.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const InvitedSubscribersView = () => {
  const pageTitle = PAGE_TITLE_LIST.INVITED_SUBSCRIBERS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListInvitedSubscribers />
    </AppLayout>
  );
};

export default InvitedSubscribersView;
